export default __webpack_public_path__ + "static/media/Samsung Galaxy Note10.afcef720.png";